<template>
  <div class="page-content">
    <div class="terms-container">
      <h1 class="terms-title">Käyttöehdot</h1>
      
      <div class="terms-content">
        <div class="terms-section">
          <h2>1. Yleistä</h2>
          <p>
            Nämä käyttöehdot koskevat Raviremmi-palvelun käyttöä. Käyttämällä palvelua hyväksyt nämä ehdot kokonaisuudessaan.
          </p>
        </div>

        <div class="terms-section">
          <h2>2. Palvelun Kuvaus</h2>
          <p>
            Raviremmi on virtuaalinen managerointipeli, jossa pelaajat kokoavat oman ravitiiminsä hevosista ja ohjastajasta. 
            Peli perustuu todellisten ravilähtöjen tuloksiin ja on suunniteltu viihdetarkoituksiin.
          </p>
          <p>
            <strong>Tärkeää:</strong> Raviremmi ei ole vedonlyöntiä eikä rahapeliä. Pelissä ei jaeta rahallisia tai materiaalisia palkintoja. 
            Pelirahaa ei voi muuttaa rahaksi eikä pelin lopputuloksesta voi saada rahapalkkiota.
          </p>
        </div>

        <div class="terms-section">
          <h2>3. Premium-tilaus ja Maksut</h2>
          <p>
            Premium-version hinta on 3,20€ per jakso. Premium-tilausta koskee kertamaksu, joka erääntyy kahden (2) päivän kuluttua laskun päiväyksestä.
          </p>
          <p>
            <strong>Maksuehdot:</strong>
          </p>
          <ul>
            <li><strong>Aktivointi:</strong> Premium-käyttöoikeus aktivoituu välittömästi tilauksen vahvistamisen jälkeen</li>
            <li><strong>Lasku:</strong> Saat automaattisesti PDF-laskun sähköpostiisi</li>
            <li><strong>Maksuaika:</strong> 2 päivää laskun päivämäärästä</li>
            <li><strong>Viitenumero:</strong> Käytä laskun viitenumeroa maksaessasi - ilman oikeaa viitenumeroa maksu ei kohdistu tilillesi</li>
            <li><strong>Maksamattomuus:</strong> Ellei maksua suoriteta eräpäivään mennessä, Premium-oikeus poistuu automaattisesti. <strong>Emme peri lisäkuluja, viivästyskorkoja tai lähetä muistutuksia.</strong></li>
            <li><strong>Ei seuraamuksia:</strong> Maksamattomuudesta ei aiheudu mitään negatiivisia seuraamuksia tai lisävelvoitteita</li>
            <li><strong>ALV:</strong> Yritys ei ole ALV-rekisterissä, joten laskussa ei ole arvonlisäveroa</li>
          </ul>
          <p>
            Myöhästyneet tai virheelliset maksut eivät oikeuta vahingonkorvaukseen.
          </p>
          <p>
            <strong>Peruuttamisoikeus:</strong> Koska Premium-käyttöoikeus aktivoituu välittömästi ja kyseessä on digitaalinen sisältö, 14 päivän peruuttamisoikeus ei ole voimassa tilauksen vahvistamisen jälkeen.
          </p>
          <p>
            <strong>Peruuttamislomake:</strong> EU:n malliperuuttamislomake on saatavilla 
            <router-link to="/peruuttamislomake" class="terms-link">täältä</router-link>, 
            vaikka peruuttamisoikeus menetetään välittömän aktivoinnin vuoksi.
          </p>
        </div>

        <div class="terms-section">
          <h2>4. Käyttäjän Velvollisuudet</h2>
          <p>Käyttäjä sitoutuu:</p>
          <ul>
            <li>Antamaan totuudenmukaisia tietoja rekisteröityessään</li>
            <li>Käyttämään palvelua asianmukaisesti ja laillisesti</li>
            <li>Olemaan häiritsemättä muita käyttäjiä</li>
            <li>Noudattamaan näitä käyttöehtoja</li>
          </ul>
        </div>

        <div class="terms-section">
          <h2>5. Tietosuoja</h2>
          <p>
            Käsittelemme henkilötietojasi huolellisesti ja tietosuojalainsäädännön mukaisesti. 
            Rekisteröitymisen yhteydessä tallennamme sähköpostiosoitteesi ja käyttäjänimesi palvelun toiminnan mahdollistamiseksi.
          </p>
        </div>

        <div class="terms-section">
          <h2>6. Palvelun Saatavuus</h2>
          <p>
            Palvelu tarjotaan "sellaisenaan". Pyrimme 98% vuosi-käyttöaikaan, mutta emme vastaa katkoista, viiveistä tai pistepäivitysten virheistä. Maksuton korvausaika on enintään Premium-jakson pituus; emme korvaa välillisiä vahinkoja.
          </p>
          <p>
            Pidätämme oikeuden keskeyttää palvelun tilapäisesti ylläpitotöiden ajaksi.
          </p>
        </div>

        <div class="terms-section">
          <h2>7. Kilpailutilanteet ja Tulokset</h2>
          <p>
            Tulokset perustuvat virallisiin ravitietoihin. Jos tuloksissa ilmenee virhe, pidätämme oikeuden korjata pisteet 30 päivän kuluessa ilman vastuuvelvoitetta.
          </p>
        </div>

        <div class="terms-section">
          <h2>8. Vastuunrajoitukset</h2>
          <p>
            Palveluntarjoaja ei vastaa epäsuorista vahingoista, ellei vahinko johdu törkeästä huolimattomuudesta tai tahallisuudesta. 
            Palvelu tarjotaan "sellaisenaan" ilman takuita.
          </p>
        </div>

        <div class="terms-section">
          <h2>9. Sopimuksen Päättyminen ja Tilin Sulkeminen</h2>
          <p>
            Voimme irtisanoa tilin tai keskeyttää pääsyn, jos käyttäjä rikkoo ehtoja tai maksua ei suoriteta. Irtisanominen ei oikeuta korvaukseen maksetusta Premium-jaksosta, ellei laki edellytä sitä.
          </p>
        </div>

        <div class="terms-section">
          <h2>10. Ehtojen Muuttaminen</h2>
          <p>
            Pidätämme oikeuden muuttaa näitä käyttöehtoja. Muutoksista ilmoitetaan palvelussa tai sähköpostitse. 
            Jatkamalla palvelun käyttöä hyväksyt muutetut ehdot.
          </p>
        </div>

        <div class="terms-section">
          <h2>11. Sovellettava Laki ja Riidanratkaisu</h2>
          <p>
            Näihin ehtoihin sovelletaan Suomen lakia. Kuluttaja voi viedä asian myös KKV:n kuluttajariitalautakuntaan.
          </p>
        </div>

        <div class="terms-section">
          <h2>12. Yhteystiedot</h2>
          <p>
            Jos sinulla on kysyttävää näistä käyttöehdoista, voit ottaa yhteyttä osoitteeseen: 
            <a href="mailto:info@raviremmi.com" class="contact-link">info@raviremmi.com</a>
          </p>
        </div>

        <div class="terms-footer">
          <p><strong>Viimeksi päivitetty:</strong> {{ lastUpdated }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService',
  data() {
    return {
      lastUpdated: '6.7.2025'
    }
  }
}
</script>

<style scoped>
.page-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.terms-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.terms-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #64ffda;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.terms-content {
  background: #112240;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
  border: 1px solid #1e3a5f;
  color: #a8b2d1;
  line-height: 1.6;
}

.terms-section {
  margin-bottom: 2rem;
}

.terms-section:last-child {
  margin-bottom: 0;
}

.terms-section h2 {
  color: #e6f1ff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #1e3a5f;
}

.terms-section p {
  margin-bottom: 1rem;
  font-size: 1rem;
}

.terms-section p:last-child {
  margin-bottom: 0;
}

.terms-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.terms-section li {
  margin-bottom: 0.5rem;
}

.contact-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.terms-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.terms-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.terms-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #1e3a5f;
  text-align: center;
  font-size: 0.9rem;
  color: #8892b0;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .terms-title {
    font-size: 1.8rem;
  }
  
  .terms-content {
    padding: 1.5rem;
  }
  
  .terms-section h2 {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .terms-content {
    padding: 1rem;
  }
  
  .terms-section ul {
    padding-left: 1.5rem;
  }
}
</style>
